export class LocalStoragePolicyStore {
    prefix;
    constructor(prefix) {
        this.prefix = prefix;
    }
    get(key) {
        try {
            return localStorage.getItem(this.prefix + key);
        }
        catch {
            return null;
        }
    }
    set(key, value) {
        try {
            localStorage.setItem(this.prefix + key, value);
        }
        catch {
            /* noop */
        }
    }
}
export function shouldShow(params) {
    const { tourId, tourVersion, cooldownDays, store } = params;
    const now = params.now ?? new Date();
    const lastSeen = store.get(`tour:lastSeen:${tourId}`);
    const lastVersion = store.get(`tour:lastVersion:${tourId}`);
    if (lastVersion === tourVersion)
        return { ok: false, reason: 'already-completed-this-version' };
    if (lastSeen) {
        const days = Math.floor((now.getTime() - Date.parse(lastSeen)) / 86400000);
        if (days < cooldownDays)
            return { ok: false, reason: 'cooldown' };
    }
    return { ok: true };
}
export function markRun(store, tourId, tourVersion) {
    store.set(`tour:lastSeen:${tourId}`, new Date().toISOString());
    store.set(`tour:lastVersion:${tourId}`, tourVersion);
}
// Global active tour cap: block launching a new tour when another is active unless allowConcurrent
export function checkGlobalCap(params) {
    const { tourId, allowConcurrent, store } = params;
    if (allowConcurrent)
        return { ok: true };
    const active = store.get('tour:active');
    if (active && active !== tourId)
        return { ok: false, reason: 'global_cap' };
    return { ok: true };
}
export function setActive(store, tourId) {
    store.set('tour:active', tourId);
}
export function clearActive(store, tourId) {
    const active = store.get('tour:active');
    if (active === tourId)
        store.set('tour:active', '');
}
//# sourceMappingURL=policy.js.map